import { images } from "../constants";
import {
  FooterCopyright,
  FooterLogo,
  FooterMetaRow,
  FooterPolicyLink,
  FooterSection,
} from "../styles";

export default function FooterSectionBlock() {
  return (
    <FooterSection>
      <FooterLogo src={images.propallyLogo} alt="Propally" />

      <FooterMetaRow>
        <div>
          〒106-0031 東京都港区西麻布三丁目20番14号
          <br />
          H1O六本木 8階
        </div>
        <div>
          TEL: 03-4500-6973
          <br />
          Email: info@propally.co.jp
        </div>
      </FooterMetaRow>

      <FooterPolicyLink
        href="https://propally.co.jp/legal/privacypolicy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        プライバシーポリシー
      </FooterPolicyLink>
      <FooterCopyright>Copyright © 2024 Propally Co.,Ltd. All rights reserved.</FooterCopyright>
    </FooterSection>
  );
}
